'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var polished = require('polished');
var PropTypes = _interopDefault(require('prop-types'));
var styled = _interopDefault(require('styled-components'));
var React = _interopDefault(require('react'));

var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var taggedTemplateLiteral = function (strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
};

var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

var _breakpointMinWidths, _gridContainerMaxWidt;

var WIDTH_XS = 'xs';
var WIDTH_SM = 'sm';
var WIDTH_MD = 'md';
var WIDTH_LG = 'lg';
var WIDTH_XL = 'xl';

var breakpointMinWidths = (_breakpointMinWidths = {}, defineProperty(_breakpointMinWidths, WIDTH_XS, polished.rem('0px')), defineProperty(_breakpointMinWidths, WIDTH_SM, polished.rem('660px')), defineProperty(_breakpointMinWidths, WIDTH_MD, polished.rem('768px')), defineProperty(_breakpointMinWidths, WIDTH_LG, polished.rem('960px')), defineProperty(_breakpointMinWidths, WIDTH_XL, polished.rem('1248px')), _breakpointMinWidths);

var gridContainerMaxWidths = (_gridContainerMaxWidt = {}, defineProperty(_gridContainerMaxWidt, WIDTH_XS, 'auto'), defineProperty(_gridContainerMaxWidt, WIDTH_SM, 'auto'), defineProperty(_gridContainerMaxWidt, WIDTH_MD, polished.rem('768px')), defineProperty(_gridContainerMaxWidt, WIDTH_LG, polished.rem('960px')), defineProperty(_gridContainerMaxWidt, WIDTH_XL, polished.rem('1248px')), _gridContainerMaxWidt);

var columns = 12;
var gutterHalfWidth = polished.rem('8px');

var constants = /*#__PURE__*/Object.freeze({
  WIDTH_XS: WIDTH_XS,
  WIDTH_SM: WIDTH_SM,
  WIDTH_MD: WIDTH_MD,
  WIDTH_LG: WIDTH_LG,
  WIDTH_XL: WIDTH_XL,
  breakpointMinWidths: breakpointMinWidths,
  gridContainerMaxWidths: gridContainerMaxWidths,
  columns: columns,
  gutterHalfWidth: gutterHalfWidth
});

var _templateObject = taggedTemplateLiteral(['', ''], ['', '']);

var getTemplate = function getTemplate(config) {
  return function (props) {
    var propNames = config.propNames,
        propNameMap = config.propNameMap,
        breakpointWidths = config.breakpointWidths,
        cssTemplate = config.cssTemplate;


    return propNames.reduce(function (css, propName) {
      var breakpoint = propNameMap[propName];

      var breakpointWidth = breakpointWidths[breakpoint];

      var value = props[propName];

      if (typeof value === 'function') {
        value = value(props, {
          css: css,
          propName: propName,
          breakpoint: breakpoint,
          breakpointWidth: breakpointWidth
        }, config);
      }

      if (typeof value !== 'string') return css;

      var newCss = cssTemplate({ breakpointWidth: breakpointWidth, value: value });
      if (typeof newCss !== 'string') return css;

      return css + ' ' + newCss;
    }, '');
  };
};

var getConfig = function getConfig(_ref) {
  var prefix = _ref.prefix,
      suffix = _ref.suffix,
      breakpointWidths = _ref.breakpointWidths;
  return Object.keys(breakpointWidths).reduce(function (_ref2, nextBreakpoint) {
    var propNameMap = _ref2.propNameMap,
        propNames = _ref2.propNames,
        propTypes = _ref2.propTypes;

    var newPropName = '' + prefix + nextBreakpoint + suffix;
    return {
      propNameMap: _extends({}, propNameMap, defineProperty({}, newPropName, nextBreakpoint)),
      propNames: [].concat(toConsumableArray(propNames), [newPropName]),
      propTypes: _extends({}, propTypes, defineProperty({}, newPropName, PropTypes.oneOfType([PropTypes.string, PropTypes.func])))
    };
  }, {
    propNameMap: {},
    propNames: [],
    propTypes: {}
  });
};

var styledBreakpoint = (function () {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref3$prefix = _ref3.prefix,
      prefix = _ref3$prefix === undefined ? '' : _ref3$prefix,
      _ref3$suffix = _ref3.suffix,
      suffix = _ref3$suffix === undefined ? '-style' : _ref3$suffix,
      _ref3$breakpointWidth = _ref3.breakpointWidths,
      breakpointWidths = _ref3$breakpointWidth === undefined ? breakpointMinWidths : _ref3$breakpointWidth,
      _ref3$cssTemplate = _ref3.cssTemplate,
      cssTemplate = _ref3$cssTemplate === undefined ? function (_ref4) {
    var breakpointWidth = _ref4.breakpointWidth,
        value = _ref4.value;
    return '@media (min-width: ' + breakpointWidth + ') { ' + value + ' }';
  } : _ref3$cssTemplate,
      _ref3$defaultProps = _ref3.defaultProps,
      defaultProps = _ref3$defaultProps === undefined ? {} : _ref3$defaultProps;

  return function (component) {
    var _getConfig = getConfig({
      prefix: prefix,
      suffix: suffix,
      breakpointWidths: breakpointWidths
    }),
        propNameMap = _getConfig.propNameMap,
        propNames = _getConfig.propNames,
        propTypes = _getConfig.propTypes;

    var template = getTemplate({
      propNameMap: propNameMap,
      propNames: propNames,
      propTypes: propTypes,
      breakpointWidths: breakpointWidths,
      cssTemplate: cssTemplate
    });

    var StyledBreakpoint = styled(component)(_templateObject, template);
    StyledBreakpoint.propTypes = propTypes;
    StyledBreakpoint.defaultProps = defaultProps;

    return {
      propNameMap: propNameMap,
      propNames: propNames,
      propTypes: propTypes,
      template: template,
      component: StyledBreakpoint
    };
  };
});

var _templateObject$1 = taggedTemplateLiteral(['\n    margin-left: -', ';\n    margin-right: -', ';\n  '], ['\n    margin-left: -', ';\n    margin-right: -', ';\n  ']);

var gridGutterRow = (function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$gutterHalfWidth = _ref.gutterHalfWidth,
      gutterHalfWidth$$1 = _ref$gutterHalfWidth === undefined ? gutterHalfWidth : _ref$gutterHalfWidth;

  return function (component) {
    var GridGutterRow = styled(component)(_templateObject$1, gutterHalfWidth$$1, gutterHalfWidth$$1);

    return GridGutterRow;
  };
});

var _templateObject$2 = taggedTemplateLiteral(['\n    ', '\n  '], ['\n    ', '\n  ']);

var gridRow = (function () {
  return function (component) {
    var GridRow = styled(component)(_templateObject$2, polished.clearFix());

    return GridRow;
  };
});

var _templateObject$3 = taggedTemplateLiteral([''], ['']);

var _styledBreakpoint = styledBreakpoint()(gridGutterRow()(gridRow()(styled.div(_templateObject$3)))),
    component = _styledBreakpoint.component;

var _templateObject$4 = taggedTemplateLiteral(['\n    box-sizing: border-box;\n    padding-left: ', ';\n    padding-right: ', ';\n  '], ['\n    box-sizing: border-box;\n    padding-left: ', ';\n    padding-right: ', ';\n  ']);

var gridGutterColumn = (function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$gutterHalfWidth = _ref.gutterHalfWidth,
      gutterHalfWidth$$1 = _ref$gutterHalfWidth === undefined ? gutterHalfWidth : _ref$gutterHalfWidth;

  return function (component) {
    var GridGutterColumn = styled(component)(_templateObject$4, gutterHalfWidth$$1, gutterHalfWidth$$1);

    return GridGutterColumn;
  };
});

var propTypeGenerator = function propTypeGenerator(test, errRequired, errInvalid) {
  return function (isRequired) {
    return function (props, propName, componentName) {
      var prop = props[propName];
      if (isRequired && !prop) return new Error(errRequired(propName, prop, componentName));
      if (!isRequired && !prop) return undefined;
      return test(prop) ? undefined : new Error(errInvalid(propName, prop, componentName));
    };
  };
};

var makeNewPropType = function makeNewPropType(test, errRequired, errInvalid) {
  var generatedPropType = propTypeGenerator(test, errRequired, errInvalid);
  var newPropType = generatedPropType();
  newPropType.isRequired = generatedPropType(true);
  return newPropType;
};

var errRequired = function errRequired(propName, prop, componentName) {
  return '"' + propName + '" supplied to "' + componentName + '" is required. Validation failed.';
};

var errInvalid = function errInvalid(propName, prop, componentName) {
  return 'Invalid prop "' + propName + '" of value "' + prop + '" supplied to "' + componentName + '". Validation failed.';
};

var CustomPropTypes = {
  cssWidth: makeNewPropType(function (prop) {
    return typeof prop === 'string' && /^[+-]?[0-9]+.?([0-9]+)?(em|ex|cap|ch|ic|rem|lh|rlh|vh|vw|vi|vb|vmin|vmax|px|mm|q|cm|in|pt|pc|mozmm)$/.test(prop);
  }, errRequired, errInvalid),
  integer: makeNewPropType(function (prop) {
    return typeof prop === 'number' && prop === parseInt(prop, 10);
  }, errRequired, errInvalid),
  integerRange: function integerRange(start, end) {
    return makeNewPropType(function (prop) {
      return typeof prop === 'number' && prop === parseInt(prop, 10) && prop >= start && prop <= end;
    }, errRequired, errInvalid);
  }
};

var gridColumnOffset = (function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$columns = _ref.columns,
      columns$$1 = _ref$columns === undefined ? columns : _ref$columns,
      _ref$styledBreakpoint = _ref.styledBreakpointOptions,
      styledBreakpointOptions = _ref$styledBreakpoint === undefined ? { suffix: '-column-offset' } : _ref$styledBreakpoint,
      _ref$defaultProps = _ref.defaultProps,
      defaultProps = _ref$defaultProps === undefined ? {} : _ref$defaultProps;

  return function (component) {
    var _styledBreakpoint = styledBreakpoint(styledBreakpointOptions)(component),
        Component = _styledBreakpoint.component,
        propNames = _styledBreakpoint.propNames;

    var GridColumnOffset = function GridColumnOffset(props) {
      var newProps = propNames.reduce(function (allNewProps, propName) {
        var value = allNewProps[propName];
        if (typeof value !== 'number') return allNewProps;

        return _extends({}, allNewProps, defineProperty({}, propName, '\n            margin-left: ' + (value === 0 ? 0 : value / columns$$1 * 100) + '%;\n          '));
      }, props);

      return React.createElement(Component, newProps);
    };

    GridColumnOffset.defaultProps = defaultProps;

    GridColumnOffset.propTypes = propNames.reduce(function (allPropTypes, propName) {
      return _extends({}, allPropTypes, defineProperty({}, propName, CustomPropTypes.integerRange(0, columns$$1 - 1)));
    }, {});

    return GridColumnOffset;
  };
});

var gridColumn = (function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$columns = _ref.columns,
      columns$$1 = _ref$columns === undefined ? columns : _ref$columns,
      _ref$styledBreakpoint = _ref.styledBreakpointOptions,
      styledBreakpointOptions = _ref$styledBreakpoint === undefined ? { suffix: '-columns' } : _ref$styledBreakpoint,
      _ref$defaultProps = _ref.defaultProps,
      defaultProps = _ref$defaultProps === undefined ? {} : _ref$defaultProps;

  return function (component) {
    var _styledBreakpoint = styledBreakpoint(styledBreakpointOptions)(component),
        Component = _styledBreakpoint.component,
        propNames = _styledBreakpoint.propNames;

    var GridColumn = function GridColumn(props) {
      var newProps = propNames.reduce(function (allNewProps, propName) {
        var value = allNewProps[propName];
        if (!value) return allNewProps;

        if (value === 'auto') {
          value = '\n            float: left;\n            width: auto;\n            max-width: 100%;\n          ';
        } else {
          var percentage = value / columns$$1 * 100;
          value = '\n            float: left;\n            width: ' + percentage + '%;\n            max-width: ' + percentage + '%;\n          ';
        }

        return _extends({}, allNewProps, defineProperty({}, propName, value));
      }, props);

      return React.createElement(Component, newProps);
    };

    GridColumn.defaultProps = defaultProps;

    GridColumn.propTypes = propNames.reduce(function (allPropTypes, propName) {
      return _extends({}, allPropTypes, defineProperty({}, propName, PropTypes.oneOfType([PropTypes.oneOf(['auto']), CustomPropTypes.integerRange(1, columns$$1)])));
    }, {});

    return GridColumn;
  };
});

var _templateObject$5 = taggedTemplateLiteral([''], ['']);

var _styledBreakpoint$1 = styledBreakpoint()(gridGutterColumn()(gridColumnOffset()(gridColumn()(styled.div(_templateObject$5))))),
    component$1 = _styledBreakpoint$1.component;

var _templateObject$6 = taggedTemplateLiteral(['\n    box-sizing: border-box;\n    margin-right: auto;\n    margin-left: auto;\n    padding-right: ', ';\n    padding-left: ', ';\n    max-width: 100%;\n  '], ['\n    box-sizing: border-box;\n    margin-right: auto;\n    margin-left: auto;\n    padding-right: ', ';\n    padding-left: ', ';\n    max-width: 100%;\n  ']);

var gridContainer = (function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$styledBreakpoint = _ref.styledBreakpointOptions,
      styledBreakpointOptions = _ref$styledBreakpoint === undefined ? { suffix: '-container' } : _ref$styledBreakpoint,
      _ref$gridContainerMax = _ref.gridContainerMaxWidths,
      gridContainerMaxWidths$$1 = _ref$gridContainerMax === undefined ? gridContainerMaxWidths : _ref$gridContainerMax,
      _ref$gutterHalfWidth = _ref.gutterHalfWidth,
      gutterHalfWidth$$1 = _ref$gutterHalfWidth === undefined ? gutterHalfWidth : _ref$gutterHalfWidth,
      defaultProps = _ref.defaultProps;

  return function (component) {
    var _styledBreakpoint = styledBreakpoint(styledBreakpointOptions)(component),
        newComponent = _styledBreakpoint.component,
        propNameMap = _styledBreakpoint.propNameMap,
        propNames = _styledBreakpoint.propNames;

    var Component = styled(newComponent)(_templateObject$6, gutterHalfWidth$$1, gutterHalfWidth$$1);

    var GridContainer = function GridContainer(props) {
      var newProps = propNames.reduce(function (allNewProps, propName) {
        var value = allNewProps[propName];
        if (!value) return allNewProps;

        return _extends({}, allNewProps, defineProperty({}, propName, 'width: ' + gridContainerMaxWidths$$1[propNameMap[propName]] + ';'));
      }, props);

      return React.createElement(Component, newProps);
    };

    GridContainer.defaultProps = defaultProps || propNames.reduce(function (allDefaultProps, propName) {
      return _extends({}, allDefaultProps, defineProperty({}, propName, gridContainerMaxWidths$$1[propNameMap[propName]]));
    }, {});

    GridContainer.propTypes = propNames.reduce(function (allPropTypes, propName) {
      return _extends({}, allPropTypes, defineProperty({}, propName, PropTypes.oneOfType([PropTypes.oneOf(['auto']), CustomPropTypes.cssWidth])));
    }, {});

    return GridContainer;
  };
});

var _templateObject$7 = taggedTemplateLiteral([''], ['']);

var _styledBreakpoint$2 = styledBreakpoint()(gridContainer()(styled.div(_templateObject$7))),
    component$2 = _styledBreakpoint$2.component;

var _templateObject$8 = taggedTemplateLiteral([''], ['']);

var _styledBreakpoint$3 = styledBreakpoint()(styled.div(_templateObject$8)),
    component$3 = _styledBreakpoint$3.component;

exports.Row = component;
exports.Column = component$1;
exports.Container = component$2;
exports.StyledBreakpoint = component$3;
exports.gridColumn = gridColumn;
exports.gridColumnOffset = gridColumnOffset;
exports.gridContainer = gridContainer;
exports.gridGutterColumn = gridGutterColumn;
exports.gridGutterRow = gridGutterRow;
exports.gridRow = gridRow;
exports.styledBreakpoint = styledBreakpoint;
exports.CustomPropTypes = CustomPropTypes;
exports.constants = constants;
//# sourceMappingURL=index.js.map
